import { Injectable } from '@angular/core';
import { CorppassProfile } from '@core/singpass';
import { ComponentStore } from '@ngrx/component-store';

type State = { state: 'idle' | 'invalid' } | { state: 'valid'; data: CorppassProfile };

const initialState: State = { state: 'idle' };

@Injectable()
export class MyInfoStore extends ComponentStore<State> {
  readonly setData = this.updater<any>((_, data) => ({ state: 'valid', data }));
  readonly selectData$ = this.select(s => (s.state === 'valid' ? s : null));
  readonly application$ = this.select(s => (s.state === 'valid' ? s.data : null));

  constructor() {
    super(initialState);
  }
}
